import type { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { HeaderMinimal } from '@xing-com/crate-layout-header-minimal';
import { Section } from '@xing-com/layout-primitives';
import { BottomBar } from '@xing-com/platform-layout-bottom-bar';
import { Footer, LegalFooter } from '@xing-com/platform-layout-footer';
import { spaceL, spaceXXL } from '@xing-com/tokens';
import { GridContainer } from '@xing-com/xing-grid';

const StyledFooter = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${spaceXXL} ${spaceL};
`;

export const UpsellFrame: FC<PropsWithChildren<{ fullFooter?: boolean }>> = ({
  children,
  fullFooter,
}) => {
  return (
    <>
      <HeaderMinimal showOnSmallerScreens />

      <main id="content">
        <Section noBlockPadding>
          <GridContainer type="wide">{children}</GridContainer>
        </Section>
      </main>

      {fullFooter ? (
        <Footer homeLink="/" />
      ) : (
        <StyledFooter>
          <LegalFooter />
        </StyledFooter>
      )}
      <BottomBar />
    </>
  );
};
